module.exports = __webpack_public_path__ + "img/INDUSTRIA_09_video_prew.74f06209.jpg";